import React from 'react';
import PropTypes from 'prop-types';
import { cn } from 'utils/cn';

export const Text = ({
  variant = 'body',
  children,
  className = '',
  as: Component = 'p',
  ...props
}) => {
  const variants = {
    display: 'text-4xl font-extrabold text-gray-900 dark:text-gray-100',
    title: 'text-2xl font-bold text-gray-900 dark:text-gray-200',
    subtitle: 'text-xl font-semibold text-gray-800 dark:text-gray-300',
    lead: 'text-lg font-medium text-gray-700 dark:text-gray-400',
    body: 'text-base',
    caption: 'text-sm text-gray-500 dark:text-gray-400',
    overline: 'text-xs uppercase tracking-wide text-gray-600 dark:text-gray-400',
    muted: 'text-gray-400 dark:text-gray-500',
    error: 'text-red-600 dark:text-red-400',
    success: 'text-green-600 dark:text-green-400',
    warning: 'text-yellow-600 dark:text-yellow-400',
    info: 'text-blue-600 dark:text-blue-400',
  };

  return (
    <Component className={cn(variants[variant], className)} {...props}>
      {children}
    </Component>
  );
};

Text.propTypes = {
  variant: PropTypes.oneOf([
    'display',
    'title',
    'subtitle',
    'lead',
    'body',
    'caption',
    'overline',
    'muted',
    'error',
    'success',
    'warning',
    'info',
  ]),
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  as: PropTypes.elementType,
};
